import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import DoneIcon from "@mui/icons-material/Done";
import TablePagination from "../../../Components/Molecules/Pagination";
import NoRecords from "../../../Components/Atoms/NoRecord";
import toast from "react-hot-toast";
import { Edit } from "@mui/icons-material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { CircularProgress } from "@mui/material";
import AvailableStatus from "../../../Components/Atoms/AvailableStatus";
import CustomButton from "../../../Components/Atoms/CustomButton";
import CustomDialog from "../../../Components/Molecules/CustomDialog";
import NewCustomRole from "./Forms/NewCustomRole";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  getCustomRoleListRequest,
  postCustomRoleResponseClear,
  putCustomRoleStatusRequest,
} from "../../../Redux/Settings/SettingsActions";
import ViewCustomRole from "./Forms/ViewCustomRole";
import { MODULES, ROLE_BY_PERMISSIONS } from "../../../Constant";
import { hasPermission } from "../../../Utils/getters";

const IndexCustomRoles = () => {
  const dispatch = useDispatch();
  const { getUserResponse } = useSelector((state) => state.user);

  const {
    getCustomRoleListLoading,
    getCustomRoleListResponse,
    postCustomRoleResponse,
    postCustomRoleLoading,
  } = useSelector((state) => state.settingsReducer);

  const [page, setPage] = useState(1);
  const searchSchema = {
    filters: {
      search: {
        value: "",
      },
    },
    limit: 10,
    page: page,
    sort: "createdAt:asc",
  };

  const searchFormik = useFormik({
    initialValues: searchSchema,
    onSubmit: (values) => {
      setPage(1);
      return dispatch(getCustomRoleListRequest(values));
    },
  });

  useEffect(() => {
    if (postCustomRoleLoading) return;
    dispatch(getCustomRoleListRequest({ ...searchFormik.values, page }));
  }, [page, postCustomRoleLoading]);

  //
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);

  const handleOpen = (type, data = null) => {
    setOpen(true);
    setData(data);
  };

  const handleClose = () => {
    setOpen(false);
  };

  //
  const [opeView, setOpenView] = useState(false);
  const handleOpenView = (data) => {
    setOpenView(true);
    setData(data);
  };
  const handleCloseView = () => {
    setOpenView(false);
  };

  useEffect(() => {
    if (postCustomRoleResponse?.success) {
      toast.success(postCustomRoleResponse?.message);
      handleClose();
    } else if (postCustomRoleResponse?.response?.data) {
      toast.error(postCustomRoleResponse?.response?.data?.message);
    }
    dispatch(postCustomRoleResponseClear());
  }, [postCustomRoleResponse]);

  return (
    <>
      <CustomDialog
        maxWidth="xl"
        title={"VIEW ROLE"}
        handleClose={() => {
          handleCloseView();
        }}
        open={opeView}
      >
        <div>
          <ViewCustomRole handleClose={handleCloseView} _id={data?._id} />
        </div>
      </CustomDialog>

      <CustomDialog
        maxWidth="md"
        title={data ? "UPDATE ROLE" : "CREATE ROLE"}
        handleClose={() => {
          handleClose();
        }}
        open={open}
      >
        <div>
          <NewCustomRole handleClose={handleClose} data={data} />
        </div>
      </CustomDialog>

      <div className="d-flex-juscon-flex-end-align-center mb-10">
        {hasPermission(
          [ROLE_BY_PERMISSIONS[MODULES.CUSTOM_ROLES].CREATE_CUSTOM_ROLES],
          getUserResponse?.data
        ) && (
          <CustomButton
            label={"New Role"}
            size="small"
            action={"NEW"}
            onClick={() => handleOpen("new")}
          />
        )}
      </div>
      {getCustomRoleListLoading &&
      !getCustomRoleListLoading?.data?.length > 0 ? (
        <div className="d-flex align-items-center justify-content-center">
          <CircularProgress size={25} />
        </div>
      ) : (
        <TablePagination
          showFilter={true}
          showSort={true}
          setPage={setPage}
          page={page}
          initialValues={searchSchema}
          formik={searchFormik}
          action={(values) => dispatch(getCustomRoleListRequest(values))}
          result={getCustomRoleListResponse}
          count={getCustomRoleListResponse?.data?.total_count}
        >
          <div className="tblWrpr">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>S.NO</th>
                    <th>ROLE</th>
                    <th>STATUS</th>
                    <th>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {getCustomRoleListResponse?.data?.length > 0 ? (
                    getCustomRoleListResponse?.data?.map((data, index) => {
                      return (
                        <tr key={data._id}>
                          <td>
                            {searchFormik?.values?.limit * (page - 1) +
                              index +
                              1}
                          </td>
                          <td> {data?.name}</td>
                          <td>
                            <AvailableStatus
                              customCls={
                                data?.status === "ACTIVE"
                                  ? "index-green"
                                  : "index-red"
                              }
                              status={data?.status}
                            />
                          </td>
                          <td>
                            <div className="view">
                              <button onClick={() => handleOpenView(data)}>
                                <VisibilityIcon />
                              </button>
                              {hasPermission(
                                [
                                  ROLE_BY_PERMISSIONS[MODULES.CUSTOM_ROLES]
                                    .STATUS_CUSTOM_ROLES,
                                ],
                                getUserResponse?.data
                              ) && (
                                <button
                                  onClick={() =>
                                    dispatch(
                                      putCustomRoleStatusRequest({
                                        _id: data?._id,
                                        status:
                                          data?.status === "ACTIVE"
                                            ? "INACTIVE"
                                            : "ACTIVE",
                                      })
                                    )
                                  }
                                >
                                  {data.status === "ACTIVE" ? (
                                    <RemoveCircleOutlineIcon />
                                  ) : (
                                    <DoneIcon />
                                  )}
                                </button>
                              )}
                              {hasPermission(
                                [
                                  ROLE_BY_PERMISSIONS[MODULES.CUSTOM_ROLES]
                                    .UPDATE_CUSTOM_ROLES,
                                ],
                                getUserResponse?.data
                              ) && (
                                <button
                                  onClick={() => handleOpen("edit", data)}
                                >
                                  <Edit />
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NoRecords />
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </TablePagination>
      )}
    </>
  );
};

export default IndexCustomRoles;
